import Update from '@/views/Update.vue';
import Items from '@/views/Items.vue';
import Item from '@/views/Item.vue';
import Questions from '@/views/Questions.vue';
import Products from '@/views/Products.vue';
import Doses from '@/views/Doses.vue';
import Drugs from '@/views/Drugs.vue';
import References from '@/views/References.vue';
import Home from '@/views/Home.vue';
import Login from '@/views/Login.vue';
import Ddx from '@/views/Ddx.vue';

let routes = [
    {
        path: "/home",
        view: 'Home',
        component: Home,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: false,
            statusBarColor: 'black',
            hideStatusBar: true
        }
    },
    {
        path: "/items",
        view: 'Items',
        component: Items,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: false,
            statusBarColor: 'black',
            hideStatusBar: true
        }
    },
    {
        path: "/items/:mode",
        view: 'ItemsMode',
        component: Items,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: false,
            statusBarColor: 'black',
            hideStatusBar: true
        }
    },
    {
        path: "/items/subtopics/:subtopic",
        view: 'ItemsSubtopic',
        component: Items,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: false,
            statusBarColor: 'black',
            hideStatusBar: true
        }
    },
    {
        path: "/",
        view: 'Update',
        component: Update,
        meta: {
            scrolling: false,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: false,
            statusBarColor: 'black',
            hideStatusBar: true
        }
    },
    {
        path: "/categories/:category/drugs/:id",
        view: 'Drugs',
        component: Drugs,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            allowZoom: true
        }
    },
    {
        path: "/categories/:category/drugs/:id/doses/:dose",
        view: 'Doses',
        component: Doses,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            allowZoom: true
        }
    },
    {
        path: "/ddx",
        view: 'Ddx',
        component: Ddx,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            allowZoom: true
        }
    },
    {
        path: "/categories/:category/products/:id",
        view: 'Products',
        component: Products,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            allowZoom: true
        }
    },
    {
        path: "/item/:id",
        view: 'Item',
        component: Item,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            allowZoom: true
        }
    },
    {
        path: "/login",
        view: 'Login',
        component: Login,
        meta: {
            scrolling: false,
            allowCopy: false,
            publicPage: true,
            collapseHeaderOnScroll: false,
            statusBarColor: 'black',
            hideStatusBar: false
        }
    },
    {
        path: "/questions",
        view: 'Questions',
        component: Questions,
        meta: {
            scrolling: false,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: false,
            statusBarColor: 'white',
            hideStatusBar: false
        }
    },
    {
        path: "/references",
        view: 'References',
        component: References,
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true,
            allowZoom: true
        }
    },
    {
        path: "/calculators/:id",
        view: 'Calculators',
        component: () => import(/* webpackChunkName: "calculators" */ '@/views/Calculators.vue'),
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true
        }
    },
    {
        path: "/calculators/continuous-infusion/custom",
        view: 'ContinuousInfusionCalculator',
        component: () => import(/* webpackChunkName: "calculators" */ '@/views/ContinuousInfusionCalculator.vue'),
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true
        }
    },
    {
        path: "/calculators/transfusion-volume-speed/custom",
        view: 'TransfusionVolumeSpeedCalculator',
        component: () => import(/* webpackChunkName: "calculators" */ '@/views/TransfusionVolumeSpeedCalculator.vue'),
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true
        }
    },
    {
        path: "/calculators/dose/custom",
        view: 'DoseCalculator',
        component: () => import(/* webpackChunkName: "calculators" */ '@/views/DoseCalculator.vue'),
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true
        }
    },
    {
        path: "/calculators/rule-of-three/custom",
        view: 'RuleOfThreeCalculator',
        component: () => import(/* webpackChunkName: "calculators" */ '@/views/RuleOfThreeCalculator.vue'),
        meta: {
            scrolling: true,
            allowCopy: false,
            publicPage: false,
            collapseHeaderOnScroll: true,
            statusBarColor: 'black',
            hideStatusBar: true
        }
    }
];
if (process.env.VUE_APP_ENV == 'admin') {
    routes = [
        {
            path: "/",
            view: 'TopicsManagement',
            component: () => import(/* webpackChunkName: "management" */ '@/views/TopicsManagement.vue'),
            meta: {
                scrolling: true,
                allowCopy: true,
                publicPage: true,
                collapseHeaderOnScroll: true,
                statusBarColor: 'black',
                hideStatusBar: true
            }
        },
        {
            path: "/categories",
            view: 'DrugsManagement',
            component: () => import(/* webpackChunkName: "management" */ '@/views/DrugsManagement.vue'),
            meta: {
                scrolling: true,
                allowCopy: true,
                publicPage: true,
                collapseHeaderOnScroll: true,
                statusBarColor: 'black',
                hideStatusBar: true
            }
        },
        {
            path: "/customers",
            view: 'CustomersManagement',
            component: () => import(/* webpackChunkName: "management" */ '@/views/CustomersManagement.vue'),
            meta: {
                scrolling: true,
                allowCopy: true,
                publicPage: true,
                collapseHeaderOnScroll: true,
                statusBarColor: 'black',
                hideStatusBar: true
            }
        },
        {
            path: "/item/:id",
            view: 'Item',
            component: Item,
            meta: {
                scrolling: true,
                allowCopy: true,
                publicPage: true,
                collapseHeaderOnScroll: true,
                statusBarColor: 'black',
                hideStatusBar: true
            }
        }
    ];
}

export default routes;